import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiRefreshCw, FiX } = FiIcons;

const UpdateNotice = () => {
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    // Check if service worker is supported
    if ('serviceWorker' in navigator) {
      // Listen for new content available event
      // This logic usually depends on how the service worker is registered
      // Since we're in a simplified environment, we'll simulate the check logic
      // In a real app with VitePWA, you'd use useRegisterSW hook
    }
  }, []);

  const handleUpdate = () => {
    if (registration && registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      setShowUpdate(false);
      window.location.reload();
    }
  };

  // Since we can't fully implement SW logic in WebContainer without a build step and SW file,
  // this component is mostly a placeholder for structure compliance
  return (
    <AnimatePresence>
      {showUpdate && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="fixed bottom-4 right-4 md:left-auto md:right-4 z-50"
        >
          <div className="bg-gray-800 text-white p-4 rounded-lg shadow-lg flex items-center space-x-4">
            <div className="flex-1">
              <p className="font-medium text-sm">New version available</p>
            </div>
            <div className="flex items-center space-x-2">
              <button
                onClick={handleUpdate}
                className="px-3 py-1.5 bg-primary-600 text-white text-xs font-medium rounded-md hover:bg-primary-500 transition-colors flex items-center"
              >
                <SafeIcon icon={FiRefreshCw} className="w-3 h-3 mr-1" />
                Update
              </button>
              <button
                onClick={() => setShowUpdate(false)}
                className="p-1.5 hover:bg-gray-700 rounded-md transition-colors"
              >
                <SafeIcon icon={FiX} className="w-4 h-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default UpdateNotice;